import React, { useEffect } from 'react';

import printJS from 'print-js-updated';

import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import { getService } from 'reducers/service';
import { useDispatch } from 'react-redux';
import { notify } from 'reducers/NotifierReducer';
import { closePrintDialog } from 'reducers/ReportsReducer';

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiDialogContent-root': {
      padding: 0,
      '& > div': {
        padding: 0,
      },
    },
  },
  reportWrap: {
    maxWidth: '100%',
    width: 1500,
    minHeight: 'calc(100vh - 140px)',
    '& > object': {
      width: '100%',
      border: 'none',
      height: 'calc(100vh - 140px)',
    },
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%', // Ensure it takes up the full width of the viewport
    height: '100vh', // Ensure it takes up the full height of the viewport
    position: 'fixed', // Fixed position to cover the entire viewport
    top: 0,
    left: 0,
    zIndex: 1000,
    pointerEvents: 'none',
  },
}));

function ExampleWindow(props) {
  const classes = useStyles();
  const { report, open, onClose, setShowPrint, setLoading } = props;
  const dispatch = useDispatch();
  useEffect(() => {
    if (!report) return;
    const { id, data, reportList, title } = report;
    if (!id || !data) return;
    getReportData(id, data, reportList, title);
  }, [report]);

  const getReportData = async (id, data, reportList, title) => {
    setLoading?.(true);
    try {
      const reportData = await getReport(id, data);

      if (reportData.ExceptionMessage) {
        dispatch(notify(reportData.ExceptionMessage, 'warning'));
        if (setShowPrint) {
          setShowPrint(false);
        }
        dispatch(closePrintDialog());
        return;
      }
      printJS({
        printable: reportData,
        type: 'pdf',
        documentTitle: title || 'RDCL Report',
        base64: true,
        onPrintDialogClose: () => onClose(id, reportList, data),
      });
    } catch (err) {
      console.log('err ', err);
      dispatch(notify(err?.message || 'Failed to generate report', 'error'));
      if (setShowPrint) {
        setShowPrint(false);
      }
      dispatch(closePrintDialog());
      if (setLoading) {
        onClose?.(id, reportList, data);
      }
    } finally {
      setLoading?.(false);
    }
  };

  const getReport = async (reportId, data) => {
    const service = getService('ssrs');
    const response = await service.get(reportId, {
      query: { data },
    });

    return response;
  };

  const renderLoader = () => (
    <div className={classes.loader}>
      <CircularProgress />
    </div>
  );

  return renderLoader();
}

export default ExampleWindow;
